import core from './commuCore'
const output = {}

function saveSection (data) {
  return core.ajax(data, '/section', 'post')
}
output.saveSection = saveSection

function updateSection (data) {
  return core.ajax(data, '/section', 'put')
}
output.updateSection = updateSection

function deleteSection (data) {
  return core.ajax(data, '/section', 'delete')
}
output.deleteSection = deleteSection

function getSection (data) {
  return core.ajax(data, '/section/', 'get')
}
output.getSection = getSection

function saveDrag (data) {
  return core.ajax(data, '/section/saveDrag', 'put')
}
output.saveDrag = saveDrag

export default output
